var convierteFormularios = function (selector) {
    if ('fetch' in window) {
        var formularios = [].slice.call(document.querySelectorAll(selector));
        formularios.forEach(function (formulario, i) {
            var progreso = document.createElement('div'), cesta = document.createElement('a');
            cesta.textContent = 'View cart';
            cesta.className = 'ver-carrito';
            cesta.setAttribute('href', '/cart/');
            formulario.appendChild(cesta);
            cesta.setAttribute('aria-hidden', 'true');
            formulario.appendChild(progreso);
            formulario.addEventListener('submit', function (e) {
                e.preventDefault();
                var boton = formulario.querySelector('button');
                if (boton) {
                    boton.disabled = true;
                }
                progreso.classList.add('anadiendo');
                cesta.setAttribute('aria-hidden', 'true');
                fetch(formulario.action, {
                    method: 'post',
                    body: new FormData(formulario)
                })
                    .then(function (x) { return x.text(); })
                    .then(function (texto) { return (new DOMParser().parseFromString(texto, 'text/html')); })
                    .then(function (dom) {
                    var carritoDestino = document.querySelector('.menu-item.cart'), carritoOrigen = dom.querySelector('.menu-item.cart');
                    progreso.classList.add('anadido');
                    progreso.classList.remove('anadiendo');
                    if (boton) {
                        boton.disabled = false;
                    }
                    setTimeout(function () {
                        progreso.classList.remove('anadido');
                        cesta.setAttribute('aria-hidden', 'false');
                    }, 1000);
                    if (carritoDestino && carritoOrigen) {
                        carritoDestino.innerHTML = carritoOrigen.innerHTML;
                    }
                });
            });
        });
    }
};
export default convierteFormularios;
